<script lang="ts" setup>
import type { ScopeGateArea } from '@ts-scope/types'

import { useGateScope } from '@composables/widgets/scope/gate-scope.hook'

defineOptions({
  name: 'GateScope',
})

const props = withDefaults(defineProps<{
  area?: ScopeGateArea
}>(), {
  area: 'page',
})

const { isSkeletonShown, skeletonComponent } = useGateScope({ area: props.area })
</script>

<template>
  <div
    v-if="isSkeletonShown"
    class="gate-scope"
  >
    <component :is="skeletonComponent" />
  </div>
  <slot v-else />
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Scope/GateScope.scss" />
